import React from 'react'
import { NodeTextArea } from '../BaseNodeTypes'
import { ContentArea } from '../styles/BaseNodeStyles'
import { useNodeEventIsolation } from '../hooks/useNodeEventIsolation'
import type { ReactFlowNodeData } from '../../../../../types/mindmap-components'

interface NodeContentProps {
  nodeTextField: {
    inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement | null>
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    handleBlur: () => void
    handleFocus: () => void
  }
  nodeData: ReactFlowNodeData
  isReadOnly: boolean
  children?: React.ReactNode
}

export const NodeContent = React.memo(
  ({ nodeTextField, nodeData, isReadOnly, children }: NodeContentProps) => {
    const isolationProps = useNodeEventIsolation({ nopan: true })

    return (
      <ContentArea>
        <NodeTextArea
          ref={nodeTextField.inputRef as React.RefObject<HTMLTextAreaElement>}
          defaultValue={nodeData.label}
          onChange={isReadOnly ? undefined : nodeTextField.handleChange}
          onBlur={isReadOnly ? undefined : nodeTextField.handleBlur}
          onFocus={isReadOnly ? undefined : nodeTextField.handleFocus}
          {...isolationProps}
          placeholder={isReadOnly ? '' : 'enter text...'}
          readOnly={isReadOnly}
        />
        {children}
      </ContentArea>
    )
  }
)
